import type { Money } from "@/lib/domain/Money";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface GetProductAndVariantsMarketPriceResponseModel {
	readonly productId: string;
	readonly tcgPlayerProductId: number;
	readonly name: string;
	readonly number: string | null;
	readonly imageUrl: string;
	readonly description: string;
	readonly cardType: string | null;
	readonly cardSubType: string | null;
	readonly class: string | null;
	readonly rarity: string | null;
	readonly cost: string | null;
	readonly defenseValue: string | null;
	readonly pitchValue: string | null;
	readonly talent: string | null;
	readonly power: string | null;
	readonly intellect: string | null;
	readonly life: string | null;
	readonly variants: VariantMarketPriceResponseModel[];
}

export interface VariantMarketPriceResponseModel {
	readonly variantId: string;
	readonly variantName: string;
	readonly marketPrice: Money | null;
	readonly fcId: string;
	readonly saleVolumes: number[];
}

export const useProduct = (productId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["product", productId],
		queryFn: () => http<GetProductAndVariantsMarketPriceResponseModel>({
			method: "GET",
			url: `/product/${productId}`
		})
	});
};
